jQuery(document).ready(function ($) {
  let isScrollingToSection = false;
  const navItemLinks = $(".studio__nav-item a");
  const sections = $("section");

  updateActiveNavItem();
  $(window).on("scroll", function () {
    if (!isScrollingToSection) {
      updateActiveNavItem();
    }
  });

  // Custom scroll-to
  navItemLinks.on("click", function (e) {
    e.preventDefault();
    const targetId = $(this).attr("href");
    const targetSection = $(targetId);

    if (targetSection.length) {
      isScrollingToSection = true;
      $("html, body").animate(
        {
          scrollTop: targetSection.offset().top,
        },
        400,
        "swing",
        function () {
          isScrollingToSection = false;
          updateActiveNavItem();
        }
      );
    }
  });

  function updateActiveNavItem() {
    const scrollPosition = $(document).scrollTop();
    const windowHeight = $(window).height();
    // const mainHeader = $("#cle-header-bar");
    // const studioNav = $("#studio__nav-bar");

    // if (scrollPosition > windowHeight / 4) {
    //   mainHeader.css("transform", "translate(0,-100%)");
    //   setTimeout(() => {
    //     studioNav.addClass("show");
    //   }, 400);
    // } else {
    //   studioNav.removeClass("show");
    //   setTimeout(() => {
    //     mainHeader.css("transform", "none");
    //   }, 400);
    // }

    sections.each(function () {
      const currentSection = $(this);
      const sectionTop = currentSection.offset().top;
      if (
        scrollPosition + windowHeight / 2 >= sectionTop &&
        scrollPosition + windowHeight / 2 < sectionTop + currentSection.outerHeight()
      ) {
        navItemLinks.parent().removeClass("active");
        const id = currentSection.attr("id");
        const currentNavItem = $('.studio__nav-item a[href="#' + id + '"]').parent();
        if (currentNavItem.length) {
          currentNavItem.addClass("active");
          currentNavItem[0].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }
    });
  }
});
